export default __webpack_public_path__ + "static/media/blue-mountains.bbfd7003.svg";